export default "__VITE_ASSET__DBuveg5v__"